/* global filter_obj, map, mapboxgl */
const $ = jQuery.noConflict();

$(document).ready(function() {
    if ($('.fm-filter-box').length) {
        const $filterCols = $('.fm-filter-col');
        const $filterMenus = $('.fm-filter-menu');
        $('.fm-filter-col .fm-filter-item').on('click', function() {
            const $parentCol = $(this).parent();
            $filterCols.not($parentCol).removeClass('active');
            $filterMenus.not($(this).next()).stop().slideUp();
            if ($parentCol.hasClass('active')) {
                $(this).next('.fm-filter-menu').stop().slideUp();
                $parentCol.stop().removeClass('active');
            } else {
                $(this).next('.fm-filter-menu').stop().slideDown();
                $parentCol.stop().addClass('active');
            }
        });
        $(document).on('click touchstart', function(e) {
            const $target = $(e.target);
            if (!$target.closest('.fm-filter-col').length) {
                $filterCols.removeClass('active');
                $filterMenus.stop().slideUp();
            }
        });
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                $filterCols.removeClass('active');
                $filterMenus.stop().slideUp();
            }
        });
    }

    $('.facilities-map input[type="checkbox"]').on('change', updateFilters);
    // Function to update filter values and enable/disable button
    function updateFilters() {

        let region = [];
        let temperatures = [];
        let logistics_cap = [];
        let value_added_service = [];
        let solution = [];
        region = $('.facilities-map input[name="region"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        temperatures = $('.facilities-map input[name="temperatures"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        logistics_cap = $('.facilities-map input[name="logistics_cap"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        value_added_service = $('.facilities-map input[name="value_added_service"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        solution = $('.facilities-map input[name="solution"]:checked').map(function() {
            return this.value;
        }).get().join(',');

        // ✅ If any checkbox is checked, enable the Apply button
        if (region || temperatures || logistics_cap || value_added_service || solution) {
            $('.submit-btn').show();
        } else {
            // $('.submit-btn').hide();
        }
    }

    $(document).on('click', '.facilities-map .icon-search', function(e) {
        e.preventDefault();
        const filter=1;
        apply_map_filter(filter);
    });

    $(document).on('keyup', '.search-input', function(e) {
        display_filter();
    });


    $(document).on('change', '.facilities-map .cat-filter', function() {
        const filter=1;
        apply_map_filter(filter);
    });

    $(document).on('click', '.facilities-map .clear-btn', function() {
        const filter=0;
        $('.submit-btn').hide();
        $('.facilities-map input[name="search_text"]').val('');

        // ✅ Uncheck all checkboxes for region, temperatures, logistics_cap, solution and value_added_service
        $('.facilities-map input[name="region"], \
            .facilities-map input[name="temperatures"], \
            .facilities-map input[name="logistics_cap"], \
            .facilities-map input[name="solution"], \
            .facilities-map input[name="value_added_service"]').prop('checked', false);

        apply_map_filter(filter);
    });

});


$(document).on('click', '.fm-filter-selected-list .fm-selected', function() {
    const filter=1;
    const fid = $(this).data('slug');
    $('.facilities-map #' + fid).prop('checked', false);
    $(this).remove();
    apply_map_filter(filter);
});

function apply_map_filter(filter) {
    let region = [];
    let temperatures = [];
    let logistics_cap = [];
    let value_added_service = [];
    let solution = [];

    $('.facilities-map .fm-filter-selected-list').empty();

    $('.facilities-map input[name="region"]:checked').each(function() {
        region.push($(this).val());
        const channel_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
        $('.fm-filter-selected-list').append('<button class="fm-selected channel-selected no-btn" data-slug="region_' + $(this).val() + '"><em class="close-icon"></em>' + channel_label + '</button>');
    });

    $('.facilities-map input[name="temperatures"]:checked').each(function() {
        region.push($(this).val());
        const channel_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
        $('.fm-filter-selected-list').append('<button class="fm-selected channel-selected no-btn" data-slug="temperatures_' + $(this).val() + '"><em class="close-icon"></em>' + channel_label + '</button>');
    });
    $('.facilities-map input[name="logistics_cap"]:checked').each(function() {
        region.push($(this).val());
        const channel_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
        $('.fm-filter-selected-list').append('<button class="fm-selected channel-selected no-btn" data-slug="logistics_cap_' + $(this).val() + '"><em class="close-icon"></em>' + channel_label + '</button>');
    });
    $('.facilities-map input[name="value_added_service"]:checked').each(function() {
        region.push($(this).val());
        const channel_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
        $('.fm-filter-selected-list').append('<button class="fm-selected channel-selected no-btn" data-slug="value_added_service_' + $(this).val() + '"><em class="close-icon"></em>' + channel_label + '</button>');
    });
    $('.facilities-map input[name="solution"]:checked').each(function() {
        region.push($(this).val());
        const channel_label = $(this).closest('li').find('label').data('label'); // Get data-label from the label
        $('.fm-filter-selected-list').append('<button class="fm-selected channel-selected no-btn" data-slug="solution_' + $(this).val() + '"><em class="close-icon"></em>' + channel_label + '</button>');
    });


    region = $('.facilities-map input[name="region"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    temperatures = $('.facilities-map input[name="temperatures"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    logistics_cap = $('.facilities-map input[name="logistics_cap"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    value_added_service = $('.facilities-map input[name="value_added_service"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    solution = $('.facilities-map input[name="solution"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    const search_keyword = $('.facilities-map input[name="search_text"]').val();

    if (region || temperatures || logistics_cap || value_added_service || solution || search_keyword!=='' ) {
        $('.submit-btn').show();
    } else {
        filter=0;
    }

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url, // Ensure correct variable name
        data: {
            action: 'fetch_location_list',
            region: region,
            temperatures: temperatures,
            logistics_cap: logistics_cap,
            value_added_service: value_added_service,
            solution: solution,
            search_keyword: search_keyword,
        },
        beforeSend: function() {
            $(document.body).css({
                'cursor': 'wait',
            });
        },
        success: function(response) {
            $(document.body).css({
                'cursor': 'default',
            });

            // console.log(response);

            if (!response || !response.features || !response.features.length) {
                // alert('please adjust search criteria and try again.');
                return;
            }

            if (response && response.type === 'FeatureCollection') {
                // ✅ Call the render function defined in your map script
                window.renderPins(response);

                const coordinates = response.features.map(f => f.geometry.coordinates);
                if (coordinates.length === 1) {
                    // Just one location — zoom in on it
                    map.flyTo({
                        center: coordinates[0],
                        zoom: 6,
                        speed: 0.8,        // 👈 slower fly speed (default is 1.2)
                        curve: 1.4,        // smooth motion (optional)
                        duration: 2500,     // 👈 3 seconds total (optional override)
                    });
                } else {
                    const regionChecked = $('.facilities-map input[name="region"]:checked');
                    const regionCount = regionChecked.length;

                    // if (regionCount === 0) {
                    //     console.log('No region checkbox is selected');
                    // } else if (regionCount === 1) {
                    //     console.log('Only one region checkbox is selected:', regionChecked.val());
                    // } else {
                    //     console.log('Multiple region checkboxes are selected:', regionChecked.map(function() {
                    //         return this.value;
                    //     }).get());
                    // }

                    // console.log(regionCount);


                    const defaultLat = parseFloat($('#default_lat').text());
                    const defaultLong = parseFloat($('#default_long').text());
                    const defaultZoom = parseFloat($('#default_zoom').text());
                    if ( parseInt(filter)===0 ) {
                        // console.log('Reset map to default view');
                        // ✅ No features — fly to default coordinates
                        map.flyTo({
                            center: [defaultLat, defaultLong],
                            zoom: defaultZoom,
                            speed: 0.8,
                            curve: 1.4,
                            duration: 2500,
                        });
                    } else if ( regionCount > 1 ) {
                        // console.log('elseif');
                        const firstCoord = coordinates[0];
                        map.flyTo({
                            center: firstCoord,
                            zoom: 3,
                            speed: 0.8,
                            curve: 1.4,
                            duration: 2500,
                        });
                    } else {
                        // console.log('else');
                        // Multiple points — fit to bounds
                        if ( regionCount===1 ) {
                            const bounds = coordinates.reduce((b, coord) => b.extend(coord), new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
                            map.fitBounds(bounds, {
                                padding: 100,
                                duration: 2500,
                                zoom: 3,
                            });
                        } else {
                            map.flyTo({
                                center: [defaultLat, defaultLong],
                                zoom: defaultZoom,
                                speed: 0.8,
                                curve: 1.4,
                                duration: 2500,
                            });
                        }
                    }
                }
            }
        },
    });
}

function display_filter() {
    let region = [];
    let temperatures = [];
    let logistics_cap = [];
    let value_added_service = [];
    let solution = [];

    region = $('.facilities-map input[name="region"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    temperatures = $('.facilities-map input[name="temperatures"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    logistics_cap = $('.facilities-map input[name="logistics_cap"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    value_added_service = $('.facilities-map input[name="value_added_service"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    solution = $('.facilities-map input[name="solution"]:checked').map(function() {
        return this.value;
    }).get().join(',');

    const search_keyword = $('.facilities-map input[name="search_text"]').val();

    if ( region || temperatures || logistics_cap || value_added_service || solution ||search_keyword!=='' ) {
        $('.submit-btn').show();
    } else {
        $('.submit-btn').hide();
    }
}